import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';

import { Currency, CurrencyType } from '../models';
import { ObjectResponse, ListResponse } from '../interfaces';
import { EntityConstants } from '../constants/entity';

@Injectable()
export class CurrenciesService extends BaseService<Currency> {
  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  // TODO: override, remove after all responses updated
  public show(id: number): Observable<ObjectResponse<Currency>> {
    return this.http.get<ObjectResponse<Currency>>(`${this.getResourceUrl()}${id}`);
  }

  // TODO: override, remove after all responses updated
  public list(queryString?: string): Observable<ListResponse<Currency>> {
    const apiUrl = this.applyQueryString(queryString);

    return this.http.get<ListResponse<Currency>>(apiUrl);
  }

  public createModalCurrencyTypeOptions(mneCurrency: Currency, entityCurrency: Currency): CurrencyType[] {
    return [
      { id: mneCurrency.currencyId, name: `${mneCurrency.isoCode} (${EntityConstants.ENTITY_TYPES.MNE})` },
      { id: entityCurrency.currencyId, name: `${entityCurrency.isoCode} (${EntityConstants.ENTITY_TYPES.ENTITY})` },
    ];
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}currencies/`;
  }
}
